module.exports = __webpack_public_path__ + "images/819b9bc8b9afadca2c31f25a05f52eb6.svg";